import { useTranslation } from '@frontend/i18n';
import { PaymentPlansCreate } from '../../components/PaymentPlansCreate';
import { PaymentsPage } from '../../components/PaymentsPage';

export const PaymentPlansCreateView = () => {
  const { t } = useTranslation('payments');

  return (
    <PaymentsPage title={t('New Payment Plan')}>
      <PaymentPlansCreate />
    </PaymentsPage>
  );
};
